import { ActionType, getType } from "typesafe-actions";
import * as qualityDocument from "./actions";
import { QualityDocumentInterface } from "./types";

const defaultState: QualityDocumentInterface = {
  _id: 0,
  authorizationno: "",
  city: "",
  clientname: "",
  company: "",
  companyname: "",
  copytoauthorizedcompany: false,
  floorfoundation: "empty",
  floorfoundationok: false,
  floorslope: undefined,
  companysupplierfloor: "",
  suppliersystemfloor: "",
  newproduction: false,
  objectname: "",
  otherinformation: "",
  discrepancies: "",
  otherleadthrough: false,
  draintype: "",
  clamptype: "",
  persontiler: {
    _id: 0,
    name: "",
  },
  personsupervisor: {
    _id: 0,
    name: "",
  },
  qualitydocumentstatus: "",
  picture: [],
  registrationno: "",
  renovation: false,
  responsibilityinsurance: "",
  sealingworkok: false,
  supplementtoclient: false,
  wallfoundation: "empty",
  wallfoundationok: false,
  floorslopenotok: false,
  tresholdok: false,
  companywallzone1supplier: "",
  suppliersystemwallzone1: "",
  companywallzone2supplier: "",
  suppliersystemwallzone2: "",
  sealingdoorwindow: false,
  pipesealingok: false,
  wellbyothercontractor: false,
  wellfixedmount: false,
  newfloordrain: false,
  welltypeapproved: false,
  wetroomamount: "",
  tilername: "",
  wetworkteamlead: "",
  floorsupplier: "",
  floorsystem: "",
  wallzone1supplier: "",
  wallzone1system: "",
  wallzone2supplier: "",
  wallzone2system: "",
  companywallzone1supplier_text: "",
  companywallzone2supplier_text: "",
  floorsupplier_text: "",
  workfrom: "",
  workto: "",
  signdate: "",
  _createdtime: "",
  version: 0,
};

export type QualityDocumentActions = ActionType<typeof qualityDocument>;

export default (
  state = defaultState,
  action: QualityDocumentActions,
): QualityDocumentInterface => {
  switch (action.type) {
    case getType(qualityDocument.setQualityDocument):
      const { payload }: any = action;
      const newStatus = payload.data.qualitydocument.qualitydocumentstatus;

      if (newStatus === "approved") {
        const data = {
          ...payload.data.qualitydocument,
        };

        const relatedDocs = payload.data.related_documents?.objects ?? [];
        if (relatedDocs.length > 0) {
          data.picture = relatedDocs.map((picture: any) => ({
            data: picture.base64_string,
            extension: picture.file_extension,
          }));
        } else {
          data.picture = Array.isArray(data.picture) ? data.picture : [];
        }

        return data;
      }

      const relatedDocs = payload.data.related_documents?.objects ?? [];
      return {
        ...payload.data.qualitydocument,
        picture: relatedDocs.map((picture: any) => ({
          data: picture.base64_string,
          extension: picture.file_extension,
        })),
      };

    case getType(qualityDocument.clearQualityDocument):
      return defaultState;

    default:
      return state;
  }
};
